// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2HySo","choiceBoxes":"toolbarselects_choiceBoxes__GqQ7P","simpleField":"toolbarselects_simpleField__t5c0k"};